import apiClient from './client';
import type {
  ReportSchedule,
  ReportScheduleCreate,
  ReportScheduleUpdate,
  ReportScheduleListItem,
  GeneratedReport,
  GeneratedReportListItem,
  ReportGenerateRequest,
  ReportGenerateResponse,
  PaginatedResponse,
} from '@/types/data';

// レポートスケジュールAPI
export const reportSchedulesApi = {
  // スケジュール一覧取得
  getSchedules: async (companyId: number, isActive?: boolean): Promise<ReportScheduleListItem[]> => {
    const params: Record<string, unknown> = { company_id: companyId };
    if (isActive !== undefined) {
      params.is_active = isActive;
    }
    const response = await apiClient.get<ReportScheduleListItem[]>('/api/reports/schedules', { params });
    return response.data;
  },

  // スケジュール作成
  createSchedule: async (data: ReportScheduleCreate): Promise<ReportSchedule> => {
    const response = await apiClient.post<ReportSchedule>('/api/reports/schedules', data);
    return response.data;
  },

  // スケジュール詳細取得
  getSchedule: async (scheduleId: number): Promise<ReportSchedule> => {
    const response = await apiClient.get<ReportSchedule>(`/api/reports/schedules/${scheduleId}`);
    return response.data;
  },

  // スケジュール更新
  updateSchedule: async (scheduleId: number, data: ReportScheduleUpdate): Promise<ReportSchedule> => {
    const response = await apiClient.put<ReportSchedule>(`/api/reports/schedules/${scheduleId}`, data);
    return response.data;
  },

  // スケジュール削除
  deleteSchedule: async (scheduleId: number): Promise<void> => {
    await apiClient.delete(`/api/reports/schedules/${scheduleId}`);
  },
};

// レポート生成API
export interface ReportHistoryParams {
  company_id: number;
  report_type?: string;
  page?: number;
  per_page?: number;
}

export const reportsApi = {
  // レポート生成
  generateReport: async (data: ReportGenerateRequest): Promise<ReportGenerateResponse> => {
    const response = await apiClient.post<ReportGenerateResponse>('/api/reports/generate', data);
    return response.data;
  },

  // レポート履歴取得
  getHistory: async (params: ReportHistoryParams): Promise<PaginatedResponse<GeneratedReportListItem>> => {
    const response = await apiClient.get<PaginatedResponse<GeneratedReportListItem>>('/api/reports/history', { params });
    return response.data;
  },

  // レポート詳細取得
  getReport: async (reportId: number): Promise<GeneratedReport> => {
    const response = await apiClient.get<GeneratedReport>(`/api/reports/history/${reportId}`);
    return response.data;
  },

  // レポートダウンロードURL取得
  getDownloadUrl: (reportId: number): string => {
    return `${apiClient.defaults.baseURL || ''}/api/reports/download/${reportId}`;
  },

  // レポートをダウンロード
  downloadReport: async (reportId: number): Promise<Blob> => {
    const response = await apiClient.get(`/api/reports/download/${reportId}`, {
      responseType: 'blob',
    });
    return response.data;
  },

  // レポート削除
  deleteReport: async (reportId: number): Promise<void> => {
    await apiClient.delete(`/api/reports/history/${reportId}`);
  },
};
